<template>
  <svg width="148" height="20" viewBox="0 0 148 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group 1597880490">
      <circle
        id="Ellipse 573"
        cx="10"
        cy="10"
        r="10"
        fill="#9EB1D5"
        class="svg-elem svg-elem-1"
      ></circle>
      <circle
        id="Ellipse 574"
        cx="42"
        cy="10"
        r="10"
        fill="#9EB1D5"
        class="svg-elem svg-elem-2"
      ></circle>
      <circle
        id="Ellipse 575"
        cx="74"
        cy="10"
        r="10"
        fill="#9EB1D5"
        class="svg-elem svg-elem-3"
      ></circle>
      <circle
        id="Ellipse 576"
        cx="106"
        cy="10"
        r="10"
        fill="#9EB1D5"
        class="svg-elem svg-elem-4"
      ></circle>
      <circle
        id="Ellipse 577"
        cx="138"
        cy="10"
        r="10"
        fill="#9EB1D5"
        class="svg-elem svg-elem-5"
      ></circle>
    </g>
  </svg>
</template>

<style scoped>
@keyframes animate-svg-fill {
  0% {
    fill: transparent;
  }

  100% {
    fill: rgb(158, 177, 213);
  }
}

.svg-elem {
  animation: animate-svg-fill 0.2s cubic-bezier(0.47, 0, 0.745, 0.715);
}

.svg-elem-1 {
  animation-delay: 1s;
}

.svg-elem-2 {
  animation-delay: 2s;
}

.svg-elem-3 {
  animation-delay: 3s;
}

.svg-elem-4 {
  animation-delay: 4s;
}

.svg-elem-5 {
  animation-delay: 5s;
  animation-iteration-count: 1;
  animation-direction: reverse;
}
</style>
